import {useEffect, useRef, useState} from "react";
import DropdownIcon from "./svg/keyboard_arrow_down.svg"

export default function OrtDropdown({children, label, slug = ''}) {
    const [active, setActive] = useState(false);
    const contentRef = useRef(null);
    const labelRef = useRef(null);

    const activeClass = active ? ' active' : '';

    useEffect(() => {
        function handleClickOutside(event) {
            if (contentRef.current && !contentRef.current.contains(event.target) && !labelRef.current.contains(event.target)) {
                setActive(false);
            }
        }

        if (open) {
            document.addEventListener("click", handleClickOutside);
        }

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [active]);

    return <div className={`ort-form__dropdown-wrapper ort-form__dropdown-wrapper--${slug}`}>
        <a className={`ort-form__dropdown-label ort-form__dropdown-label--${slug}${activeClass}`} ref={labelRef} onClick={() => setActive(!active)}>
            {label}
            <DropdownIcon className="ort-form__dropdown-icon" />
        </a>
        <div className={`ort-form__dropdown ort-form__dropdown--${slug}`} ref={contentRef}>
            {children}
        </div>
        <div className="ort-form__dropdown-shadow" />
    </div>
}
